import InputText2 from './InputText2';
export default InputText2;
